<script lang="ts" setup>
import IconClose from '~/assets/icons/icon-close.svg?component'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  dataTestId: {
    type: String,
    default: '',
  },
  // Spacing under the header slot; drawers with their own header layout pass ''.
  headerClass: {
    type: String,
    default: 'mb-4',
  },
})
</script>

<template>
  <!-- drawer component -->
  <div
    id="drawer"
    class="shadow-lg overflow-hidden fixed top-0 right-0 z-40 h-screen p-4 overflow-y-auto transition-transform duration-300 bg-white w-80"
    :class="[
      {
        'translate-x-full': !props.isOpen,
        'translate-none': props.isOpen,
      },
    ]"
    :style="{
      clipPath: props.isOpen ? 'none' : 'inset(0 -100% 0 0)',
    }"
    tabindex="-1"
    aria-labelledby="drawer-right-label"
  >
    <div :class="props.headerClass">
      <slot name="header"> </slot>
      <button
        type="button"
        aria-controls="drawer"
        aria-label="Close"
        :data-test-id="`${dataTestId}-close-button`"
        class="close-button"
        @click="$emit('click:close')"
      >
        <IconClose />
        <span class="sr-only">Close menu</span>
      </button>
    </div>

    <slot></slot>
  </div>
</template>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
.close-button {
  @apply hover:rotate-90 duration-300 w-[22px] h-[22px];
  @apply absolute top-3.5 md:top-4 inset-e-2.5 mt-1 inline-flex items-center justify-center;

  &:hover {
    svg path {
      fill: #000;
    }
  }
}
</style>
